import { List } from "@portal/BaseComponents/List/AntList";
import { DocumentList } from "@portal/types/entities/documents";
import { styled } from "@stitches/react";

export const DocumentTitleList = styled(List<DocumentList>, {
  width: "100%",
  ".ant-list-item": {
    padding: 0,
  },
  "&.ant-list .ant-list-item .ant-list-item-meta .ant-list-item-meta-avatar": {
    marginInlineEnd: "var(--space-8) !important",
  },
  "&.ant-list .ant-list-item .ant-list-item-meta .ant-list-item-meta-title": {
    marginBottom: 0,
  },
});
